module.exports = __webpack_public_path__ + "static/media/post-laugh.f4323e3a.svg";